import React, {Component} from 'react';
import styles from "./evaluateclass.module.css";


import closeIcon from "../../img/bt-close.png";
import JichuZhang from "./honglingjin/jichuZhang/jichuZhang.jsx";
import TeseZhang from "./honglingjin/teseZhang/teseZhang.jsx";
import YixingZhang from "./honglingjin/yixingZhang/yixingZhang.jsx";
import LaodongJiaoyu from "./laodongjiaoyu/laodongJiaoyu.jsx";

const Evaluate = props => (
    <div className={styles["modal-overlay"]}>
        <div className={styles["modal-content"]}>
            <div className={styles.titlebar}>
                <div className={styles["text-name"]}>
                    评价 {props.student_name}
                </div>

                <img
                    className={styles.close}
                    src={closeIcon}
                    onClick={props.onRequestClose}
                />
            </div>

            <div className={styles["list-warpper"]}>
                <div className={styles["list-item"]}>
                    <div className={props.tab == 0 ? styles["xueyuan-selected"] : styles["xueyuan-unselected"]}
                         onClick={props.clickTab.bind(null, 0)}>
                        积极向上
                    </div>
                    {props.tab == 0 ?
                        <div className={styles.line}></div>
                        : null}

                </div>
                <div className={styles["list-item"]}>
                    <div className={props.tab == 1 ? styles["xueyuan-selected"] : styles["xueyuan-unselected"]}
                         onClick={props.clickTab.bind(null, 1)}>
                        有待改进
                    </div>
                    {props.tab == 1 ?
                        <div className={styles.line}></div>
                        : null}

                </div>
            </div>

            {props.tab == 0 ?
                <div className={styles["list-warpper-xueke"]}>
                    {
                        props.dianzanList.map((item, index) => {
                            return (
                                <div className={styles["list-item-xueke"]}>
                                    <div
                                        className={props.xueke_code == item.fenlei_code ? styles["xueke-selected"] : styles["xueke-unselected"]}
                                        onClick={props.clickXueke.bind(null, item.fenlei_code, index)}>
                                        {item.fenlei_name}
                                    </div>
                                </div>);
                        })
                    }
                </div> :
                <div className={styles["list-warpper-xueke"]}>
                    {
                        props.gaijinList.map((item, index) => {
                            return (
                                <div className={styles["list-item-xueke"]}>
                                    <div
                                        className={props.xueke_code == item.fenlei_code ? styles["xueke-selected"] : styles["xueke-unselected"]}
                                        onClick={props.clickXueke.bind(null, item.fenlei_code, index)}>
                                        {item.fenlei_name}
                                    </div>
                                </div>);
                        })
                    }
                </div>
            }

                <div className={styles["list-warpper-liyou"]}>
                    {
                        props.liyouList.map((item) => {
                            return (
                                <div className={styles["item-liyou"]}
                                     onClick={props.clickLiyou.bind(null, item.code)}>
                                    {item.liyou}
                                </div>
                            );
                        })
                    }
                </div>



        </div>
    </div>
)

export default Evaluate;
